module.exports = __webpack_public_path__ + "img/beyond.5365bc37.jpg";